import { Divider as DefaultDivider } from "@mui/material";

const Divider = (props: any) => {
    return (
        <DefaultDivider {...props} />
    );
};

export default Divider;